var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_68_316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9945 22V21.9991H22V13.9306C22 9.98345 21.1502 6.94287 16.5357 6.94287C14.3174 6.94287 12.8287 8.1602 12.221 9.31429H12.1568V7.31137H7.78156V21.9991H12.3374V14.7263C12.3374 12.8114 12.7004 10.9597 15.0718 10.9597C17.4084 10.9597 17.4432 13.145 17.4432 14.8491V22H21.9945Z",
    fill: "#273043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.363007 7.3125H4.92434V22.0002H0.363007V7.3125Z",
    fill: "#273043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.64183 0C1.18342 0 0 1.18342 0 2.64183C0 4.10025 1.18342 5.30842 2.64183 5.30842C4.10025 5.30842 5.28367 4.10025 5.28367 2.64183C5.28275 1.18342 4.09933 0 2.64183 0V0Z",
    fill: "#273043"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_68_316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.0b467ad9d252844819915271df76b123.svg";
export { ForwardRef as ReactComponent };